import { render, staticRenderFns } from "./CommRec.vue?vue&type=template&id=085bfbf1&"
import script from "./CommRec.vue?vue&type=script&lang=js&"
export * from "./CommRec.vue?vue&type=script&lang=js&"
import style0 from "./CommRec.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\customControl\\custom_stage_lv\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('085bfbf1')) {
      api.createRecord('085bfbf1', component.options)
    } else {
      api.reload('085bfbf1', component.options)
    }
    module.hot.accept("./CommRec.vue?vue&type=template&id=085bfbf1&", function () {
      api.rerender('085bfbf1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/commRecord/components/CommRec.vue"
export default component.exports